import { useCallback, useSyncExternalStore } from "react";
import { QueryClient, useQueryClient } from "@tanstack/react-query";

import { TruckLoadDTO } from "../../../DTOs/Production/TruckLoadDTO";
import { PagedResult } from "../../../DTOs/Common/PagedResult";

const cachedShiftTotal = (queryClient: QueryClient, diggingPatternId: number) => {
  // Note: the same load can be cached under several keys, filtered and sorted differently, so it is counted once.
  const loadsById = new Map<number, number>()
  let unidentified = 0
  for (const [, page] of queryClient.getQueriesData<PagedResult<TruckLoadDTO>>({
    queryKey: ['dataTable', 'chatree', 'truckLoads', diggingPatternId],
  })) {
    for (const row of page?.data ?? []) {
      const loads = Number(row?.loads) || 0
      if (typeof row?.loadingId === 'number') loadsById.set(row.loadingId, loads)
      else unidentified += loads
    }
  }
  let total = unidentified
  for (const loads of loadsById.values()) total += loads
  return total
};

export const useOfflineShiftTotal = (diggingPatternId: number, isOnline: boolean) => {
  const queryClient = useQueryClient();
  const subscribe = useCallback(
    (onCacheChange: () => void) => queryClient.getQueryCache().subscribe(onCacheChange),
    [queryClient]);

  return useSyncExternalStore(subscribe, () => isOnline ? undefined : cachedShiftTotal(queryClient, diggingPatternId));
};
